<template>
  <div>
    <HomeSection v-bind:homeitem="group" v-for="(group, idx) in homeData" :key="idx" class="home-element" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import homeApi from '@/api/home-api'
import HomeSection from './_components/HomeSection'
//import promotion from '@/common/promotion'

export default {
  name: 'HomeModule',
  components: {
    HomeSection,
  },
  computed: {
    ...mapGetters({
      home: 'home',
      locale: 'locale',
    }),
  },
  data() {
    return {
      homeData: [],
    }
  },
  methods: {
    async refreshData() {
      let homeData = await homeApi.getGroups(this.home)
      let results = []
      for (let elm of this.home.filter(f => f.locale == this.locale)) {
        let hd = homeData.find(f => f.name == elm.name && f.value == elm.value && f.locale == this.locale)
        if (hd) {
          elm.items = hd.items
        }
        results.push(elm)
      }
      this.homeData = results
    },
  },
  created() {
    this.$store.subscribe(async mutation => {
      if (mutation.type == 'LOCALE_CHANGED') {
        this.$store.dispatch('$_search/getProducts', this.filter)
        await this.refreshData()
      }
    })
  },
  async mounted() {
    await this.refreshData()
  },
  metaInfo() {
    const title = 'Hallo'

    let metaDescription = `Durchstöbern Sie unsere ${this.currentTitle} Angebote und wählen Sie Ihren gewünschten Kurzurlaub aus! Reisen Sie clever & günstig mit Urlaubsgutscheinen!`

    if (this.$route.name === 'home' && this.$whitelabel.metaDescription != undefined) {
      metaDescription = this.$whitelabel.metaDescription
    }

    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: metaDescription,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.home-element {
  margin-top: 3rem;
  margin-bottom: 3rem;

  @media screen and (min-width: 1024px) {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
}
</style>
